/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgDatabasePlusBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.99561 5.47826C1.99561 5.93503 2.20931 6.38733 2.62451 6.80933C3.03971 7.23134 3.64828 7.61478 4.41547 7.93776C5.18266 8.26075 6.09344 8.51696 7.09583 8.69175C8.09821 8.86655 9.17256 8.95652 10.2575 8.95652C11.3425 8.95652 12.4168 8.86655 13.4192 8.69175C14.4216 8.51696 15.3324 8.26075 16.0996 7.93776C16.8668 7.61478 17.4753 7.23134 17.8905 6.80933C18.3057 6.38733 18.5194 5.93503 18.5194 5.47826M1.99561 5.47826C1.99561 5.02149 2.20931 4.56919 2.62451 4.14719C3.03971 3.72519 3.64828 3.34175 4.41547 3.01876C5.18266 2.69577 6.09344 2.43957 7.09583 2.26477C8.09821 2.08997 9.17256 2 10.2575 2C11.3425 2 12.4168 2.08997 13.4192 2.26477C14.4216 2.43957 15.3324 2.69577 16.0996 3.01876C16.8668 3.34175 17.4753 3.72519 17.8905 4.14719C18.3057 4.56919 18.5194 5.02149 18.5194 5.47826M1.99561 5.47826V16.7826C1.99561 18.58 5.23428 20.0592 9.38785 20.2418M18.5194 5.47826V9.3913M10.2575 12.4339C5.69521 12.4339 1.99561 10.8774 1.99561 8.95567M8.95301 16.3035C5.01077 16.0426 1.99561 14.6035 1.99561 12.8696M16.7775 14.1739V19.3913M19.3866 16.7826H14.1685M11.5595 16.7826C11.5595 17.4678 11.6945 18.1462 11.9567 18.7792C12.2189 19.4122 12.6033 19.9874 13.0878 20.4719C13.5724 20.9563 14.1476 21.3407 14.7807 21.6028C15.4138 21.865 16.0923 22 16.7775 22C17.4628 22 18.1413 21.865 18.7744 21.6028C19.4075 21.3407 19.9827 20.9563 20.4673 20.4719C20.9518 19.9874 21.3362 19.4122 21.5984 18.7792C21.8606 18.1462 21.9956 17.4678 21.9956 16.7826C21.9956 15.3989 21.4458 14.0718 20.4673 13.0934C19.4887 12.1149 18.1615 11.5652 16.7775 11.5652C15.3936 11.5652 14.0664 12.1149 13.0878 13.0934C12.1093 14.0718 11.5595 15.3989 11.5595 16.7826Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgDatabasePlus = wrapIcon(SvgDatabasePlusBase);
export default SvgDatabasePlus;
